export function getOrderItemsQueryByLastNWeeksWithLimitOffset(weeks: number, limit: number): string {
  return `SELECT 
  Id, CreatedDate, UnitPrice, Quantity, Master_Order_Product__r.Id, Master_Order_Product__r.Product_MPN__c, 
  Order.Id, Order.Account.Id, Order.Account.Name, Order.Name, Order.ShippingCountry, Order.Order_Time__c,
  Order.Status__c, Order.Order_Routing_Exception_Reason__c, Order.ShippingPostalCode, Order.ShippingState, Order.ShippingCity,
  Order.Estimated_Ship_Date__c, Order.Deliver_By_Date__c, Order.External_Order_ID__c,
  Product2.Id, Product2.MPN__c, Product2.Image_URL_1__c, Product2.Title__c,  
  Shipping_Detail__r.Shipping_Status__c, Shipping_Detail__r.Azure_Status__c, 
  Shipping_Detail__r.Fulfilled_by_Software__c, Shipping_Detail__r.ShipStation_Order_Id__c, 
  Shipping_Detail__r.Tracking_Number__c, Shipping_Detail__r.Fulfilled_by_Software_URL__c, 
  Shipping_Detail__r.Shipment_Uploaded_Time__c, Shipping_Detail__r.Invoice_Uploaded_Time__c,
  Shipping_Detail__r.Shipment_Time__c, Shipping_Detail__r.Shipment_Sent_Time__c, Shipping_Detail__r.Shipping_Carrier__c,
  Inventory__r.Id, Inventory__r.Name, Inventory__r.Fulfillable_Inventory__c
FROM OrderItem
WHERE CreatedDate >= LAST_N_WEEKS:${weeks}
ORDER BY Order.Order_Time__c DESC, Order.Name 
LIMIT ${limit} 
`
}